import { FC } from 'react'

const PendingAction: FC<React.SVGProps<SVGSVGElement>> = ({
  className,
  height,
  width,
  ...rest
}) => {
  return (
    <svg
      className={className}
      width={width || '22'}
      height={height || '22'}
      viewBox='0 0 22 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <circle cx='11' cy='11' r='11' fill='#FECD34' />
      <path
        d='M14.3889 10.8571C12.3956 10.8571 10.7778 12.4571 10.7778 14.4286C10.7778 16.4 12.3956 18 14.3889 18C16.3822 18 18 16.4 18 14.4286C18 12.4571 16.3822 10.8571 14.3889 10.8571ZM15.5806 16.1071L14.0278 14.5714V12.2857H14.75V14.2786L16.0861 15.6L15.5806 16.1071ZM15.1111 4.42857H12.8144C12.5111 3.6 11.7167 3 10.7778 3C9.83889 3 9.04444 3.6 8.74111 4.42857H6.44444C5.65 4.42857 5 5.07143 5 5.85714V16.5714C5 17.3571 5.65 18 6.44444 18H10.8572C10.4311 17.5929 10.0844 17.1071 9.83167 16.5714H6.44444V5.85714H7.88889V8H13.6667V5.85714H15.1111V9.48571C15.6239 9.55714 16.1078 9.70714 16.5556 9.91429V5.85714C16.5556 5.07143 15.9056 4.42857 15.1111 4.42857ZM10.7778 5.85714C10.3806 5.85714 10.0556 5.53571 10.0556 5.14286C10.0556 4.75 10.3806 4.42857 10.7778 4.42857C11.175 4.42857 11.5 4.75 11.5 5.14286C11.5 5.53571 11.175 5.85714 10.7778 5.85714Z'
        fill='white'
      />
    </svg>
  )
}

export default PendingAction
